import React, { ComponentProps } from "react";
import * as RadixSelect from "@radix-ui/react-select";
import { SVG } from "../SVG";
import { theme } from "../../styles";
import * as styles from "./styles";
import ChevronIcon from "~/components/deprecated/assets/chevron.svg";
import CheckIcon from "~/components/deprecated/assets/check.svg";

/**
 * Trigger
 */
type TriggerProps = {
  size?: "medium" | "large";
} & ComponentProps<typeof RadixSelect.Trigger>;

const Trigger = ({ size = "medium", children, ...props }: TriggerProps) => (
  <RadixSelect.Trigger className={styles.trigger} data-size={size} {...props}>
    {children}
    <RadixSelect.SelectIcon>
      <SVG
        SVGElement={ChevronIcon}
        fill={theme["--ll-color-on-background-variant1"]}
      />
    </RadixSelect.SelectIcon>
  </RadixSelect.Trigger>
);

/**
 * Content
 */
type ContentProps = {
  size?: "medium" | "large";
} & ComponentProps<typeof RadixSelect.Content>;

const Content = ({ size = "medium", children, ...props }: ContentProps) => (
  <RadixSelect.Content className={styles.content} data-size={size} {...props}>
    <RadixSelect.Viewport className={styles.viewport}>
      {children}
    </RadixSelect.Viewport>
  </RadixSelect.Content>
);

/**
 * Item
 */
type ItemProps = {
  variant?: "dark" | "light";
} & ComponentProps<typeof RadixSelect.Item>;

const Item = ({ variant = "dark", children, ...props }: ItemProps) => (
  <RadixSelect.Item className={styles.item} data-variant={variant} {...props}>
    <RadixSelect.ItemText>{children}</RadixSelect.ItemText>
    <RadixSelect.ItemIndicator className={styles.itemIndicator}>
      <SVG SVGElement={CheckIcon} fill="currentColor" height={12} width={12} />
    </RadixSelect.ItemIndicator>
  </RadixSelect.Item>
);

/**
 * Portal
 */
const Portal = () => <RadixSelect.Portal></RadixSelect.Portal>;

/**
 * Group
 */
type GroupProps = {
  label: string;
} & ComponentProps<typeof RadixSelect.Group>;

const Group = ({ children, label, ...props }: GroupProps) => (
  <RadixSelect.Group {...props}>
    <RadixSelect.Label>{label}</RadixSelect.Label>
    {children}
  </RadixSelect.Group>
);

const { Root } = RadixSelect;
export { Root, Trigger, Content, Item, Portal, Group };
